export default __webpack_public_path__ + "static/media/parties.8fc182ad.svg";